
export class NVD3Util {

    public static findAllTooltips(): Array<HTMLElement> {
        return Array.from(document.querySelectorAll(".nvtooltip"));
    }

    public static nukeAllTooltips() {
        const tooltips = NVD3Util.findAllTooltips();
        tooltips.forEach(tt => tt.remove());
    }

    public static hideAllTooltips() {
        const tooltips = NVD3Util.findAllTooltips();
        tooltips.forEach(tt => tt.style.opacity = "0");
    }
}